import React from 'react'
import "./Loading.css";

function Loading() {
  return (
	<div className="window loading">
		<span></span>
	</div>
  )
}

export default Loading